import React, { useEffect, useRef } from "react";
import SprintRow from "./SprintRow";

function SprintsTable({ sprints, projectId, projectName, selection }) {
  const selectAllRef = useRef(null);

  // indeterminate não existe como atributo no HTML: só é alcançável pela
  // propriedade do nó, e é ela que distingue "algumas" de "nenhuma".
  useEffect(() => {
    if (selectAllRef.current) selectAllRef.current.indeterminate = selection.someSelected;
  }, [selection.someSelected]);

  return (
    <table className="data-table">
      <thead>
        <tr>
          <th scope="col" className="col-check">
            <span className="checkcell">
              <input
                type="checkbox"
                ref={selectAllRef}
                checked={selection.allSelected}
                onChange={selection.toggleAll}
                aria-label="Selecionar todas as sprints do projeto"
              />
            </span>
          </th>
          <th scope="col">Sprint</th>
          <th scope="col" className="col-status">
            Situação
          </th>
          <th scope="col" className="col-due">
            Encerramento
          </th>
        </tr>
      </thead>

      <tbody>
        {sprints.map((sprint) => (
          <SprintRow
            key={sprint.id}
            sprint={sprint}
            projectId={projectId}
            projectName={projectName}
            selected={selection.isSelected(sprint.id)}
            onToggle={selection.toggle}
          />
        ))}
      </tbody>
    </table>
  );
}

export default SprintsTable;
